import { render, staticRenderFns } from "./WelcomePanel.component.html?vue&type=template&id=ffeddbd8&scoped=true&"
import script from "./WelcomePanel.component.ts?vue&type=script&lang=ts&"
export * from "./WelcomePanel.component.ts?vue&type=script&lang=ts&"
import style0 from "./WelcomePanel.component.scss?vue&type=style&index=0&id=ffeddbd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeddbd8",
  null
  
)

export default component.exports